import { Parcel } from "../../../../model/parcel";
import { IParcelDocumentProvider } from "./parcel-document-provider-interface";
import { parcelsService } from "../../../../services/parcels";
import { ParcelDocument } from "./parcel-document";
import { DocumentFormat } from "../document-printer";
import { MultiParcelDocument } from "./multiparcel-document";
import { IMultiParcelDocumentProvider } from "./multiparcel-document-provider-interface";
import { ParcelDetailsArrangement } from "../../../../model/parcel-details-arrangement";

class PreparationOrderProvider implements IParcelDocumentProvider, IMultiParcelDocumentProvider {
    private readonly _hasLabel = false;
    private readonly _hasPreparationOrder = true;

    public get hasLabel(): boolean {
        return this._hasLabel;
    }

    public get hasPreparationOrder(): boolean {
        return this._hasPreparationOrder;
    }

    public async fetch(operationCode: string, batchId: number, parcel: Parcel): Promise<ParcelDocument> {
        const preparationOrderFile = await parcelsService.preparationOrder(operationCode, batchId, parcel.id, parcel.detailProductIds);

        return new ParcelDocument(parcel.id, DocumentFormat.Pdf, preparationOrderFile ? preparationOrderFile.Value! : undefined);
    }

    public async fetchMultiparcel(operationCode: string, batchId: number, parcel: Parcel[]): Promise<MultiParcelDocument> {
        const response = await parcelsService.multipageDocument(operationCode, batchId, parcel.map(p => p.id), "PreparationOrder",
            parcel.map(p => ParcelDetailsArrangement.createFromParcel(p)));

        return new MultiParcelDocument(response.succeededParcelIds, DocumentFormat.Pdf, response.file ?? undefined);
    }
}

export const preparationOrderProvider = new PreparationOrderProvider();
